export default function MoviePageLoader() {
  return (
    <div className="loader__container">
      <div className="loader loader--movie-page"></div>
    </div>
  );
}
